import { Fragment } from "react";
import StaedteError from "./Error";

export default function Degrees(params) {

    const degreesData = params.data;

    let errorOccured = undefined !== degreesData.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === degreesData || 0 === degreesData.length ) {
        return;
    }

    return(
        <div className="staedte-degrees-container">

            <p className="staedte-degrees-header">
                <b>
                    {window.staedteFrontendShortcodeData.i18n.degrees}
                </b>
            </p>

            <div className="staedte-degrees-wrapper">
                {
                    degreesData.degree_names.map(
                        (degreeName, index) => {
                            return(

                                <div key={index} className="staedte-degree-card text-decoration-none">
                                    <div className="card">

                                        <div
                                            className="staedte-degrees-img-wrapper"
                                        >
                                            {/* TODO: Add deault img for degrees with no image */}
                                            <img
                                                className={'staedte-degrees-img'}
                                                alt={degreeName} src={`https://bierbachelor.com/${degreesData.degree_images[index]}`}
                                            />
                                        </div>

                                        <div className="staedte-degrees-text">
                                            <b>{degreeName}</b>
                                        </div>

                                    </div>
                                </div>

                            )
                        }
                    )
                }
            </div>
        </div>
    );

}